module.exports = __webpack_public_path__ + "img/activity_05.0af3178a.jpg";